import { gql } from '@apollo/client';

export const ALL_ACTIVITY_SERVICES = gql`
  query AllActivityServices($activityId: ID!) {
    services: allActivityServices(activityId: $activityId) {
      id
      name
      categories {
        id
        name
      }
    }
  }
`;
